import { useState } from "react"
import { useInView } from "react-intersection-observer"
import { useShallow } from "zustand/react/shallow"
import { Flex } from "antd"

// components
import CellActions from "../CellActions/CellActions"
import Label from "components/Label/Label"
import CellValidation from "../../../components/CellValidation/CellValidation"
import { InputNumber } from "components-design-system"

// context
import useAuthoringViewStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringViewStore"

// styles
import "./Cell.scss"

const Cell = ({ cell, row, onChange, saveComment, jpath, type, errorKey, tableView, unitsAnalyzed }) => {
  const { readOnly } = useAuthoringViewStore(useShallow((state) => ({ readOnly: state.readOnly })))

  const { ref: visibleRef, inView: inViewport } = useInView({
    /* Optional options */
    threshold: 0,
    triggerOnce: true,
  })
  const [showActions, setShowActions] = useState(false)

  return (
    <td
      ref={visibleRef}
      onMouseEnter={() => setShowActions(true)}
      onMouseLeave={() => setShowActions(false)}
    >
      <Flex
        justify="space-between"
        align="center"
      >
        {inViewport ? (
          <div className="pf-cell-container">
            <div
              className="pf-cell-wrapper"
              style={{ gap: 8 }}
            >
              <div className="pf-cell-inputs-container">
                <InputNumber
                  id={`${jpath}-field-id`}
                  readOnly={readOnly}
                  value={cell?.value}
                  onChange={(e) => onChange(e, row, cell, "value")}
                  placeholder="Participants"
                  style={{ width: "100%" }}
                />
                {unitsAnalyzed && tableView === "ctg" && type === "milestone_list" && (
                  <InputNumber
                    id={`${jpath}-units-achieve`}
                    value={cell?.units_achieve}
                    readOnly={readOnly}
                    placeholder={`Units (${unitsAnalyzed})`}
                    onChange={(e) => onChange(e, row, cell, "units_achieve")}
                    style={{ width: "100%" }}
                  />
                )}
              </div>
            </div>
            {cell?.comment && <Label style={{ marginTop: 6 }}>{cell?.comment}</Label>}
          </div>
        ) : (
          <div style={{ padding: 10 }} />
        )}

        <CellActions
          showActions={showActions}
          setShowActions={setShowActions}
          comment={cell?.comment}
          saveComment={(comment) => saveComment(comment, row, cell)}
          jpath={jpath}
          type={type}
        />
      </Flex>
      <CellValidation
        table="participants"
        errorKey={errorKey}
      />
    </td>
  )
}

export default Cell
